import { useEffect } from "react";

export default function useSeo({
    title,
    description,
    canonical,
    keywords,
    ogTitle,
    ogDescription,
    ogUrl,
    ogType = "website"
}) {
    useEffect(() => {
        // Title
        if (title) {
            document.title = title;
        }

        // Description
        if (description) {
            let metaDesc = document.querySelector("meta[name='description']");
            if (!metaDesc) {
                metaDesc = document.createElement("meta");
                metaDesc.setAttribute("name", "description");
                document.head.appendChild(metaDesc);
            }
            metaDesc.setAttribute("content", description);
        }

        // Keywords
        if (keywords) {
            let metaKeywords = document.querySelector("meta[name='keywords']");
            if (!metaKeywords) {
                metaKeywords = document.createElement("meta");
                metaKeywords.setAttribute("name", "keywords");
                document.head.appendChild(metaKeywords);
            }
            metaKeywords.setAttribute("content", keywords);
        }

        // Canonical URL
        if (canonical) {
            let linkCanonical = document.querySelector("link[rel='canonical']");
            if (!linkCanonical) {
                linkCanonical = document.createElement("link");
                linkCanonical.setAttribute("rel", "canonical");
                document.head.appendChild(linkCanonical);
            }
            linkCanonical.setAttribute("href", canonical);
        }

        // Open Graph
        if (ogTitle) {
            let metaOgTitle = document.querySelector("meta[property='og:title']");
            if (!metaOgTitle) {
                metaOgTitle = document.createElement("meta");
                metaOgTitle.setAttribute("property", "og:title");
                document.head.appendChild(metaOgTitle);
            }
            metaOgTitle.setAttribute("content", ogTitle);
        }

        if (ogDescription) {
            let metaOgDesc = document.querySelector("meta[property='og:description']");
            if (!metaOgDesc) {
                metaOgDesc = document.createElement("meta");
                metaOgDesc.setAttribute("property", "og:description");
                document.head.appendChild(metaOgDesc);
            }
            metaOgDesc.setAttribute("content", ogDescription);
        }

        if (ogUrl) {
            let metaOgUrl = document.querySelector("meta[property='og:url']");
            if (!metaOgUrl) {
                metaOgUrl = document.createElement("meta");
                metaOgUrl.setAttribute("property", "og:url");
                document.head.appendChild(metaOgUrl);
            }
            metaOgUrl.setAttribute("content", ogUrl);
        }

        if (ogType) {
            let metaOgType = document.querySelector("meta[property='og:type']");
            if (!metaOgType) {
                metaOgType = document.createElement("meta");
                metaOgType.setAttribute("property", "og:type");
                document.head.appendChild(metaOgType);
            }
            metaOgType.setAttribute("content", ogType);
        }

        // Robots
        let metaRobots = document.querySelector("meta[name='robots']");
        if (!metaRobots) {
            metaRobots = document.createElement("meta");
            metaRobots.setAttribute("name", "robots");
            document.head.appendChild(metaRobots);
        }
        metaRobots.setAttribute("content", "index, follow");

    }, [title, description, canonical, keywords, ogTitle, ogDescription, ogUrl, ogType]);
}
